import { Skeleton } from "@/components/ui/skeleton";

function JobDetailsHeaderSkeleton() {
  return (
    <div className="flex flex-col gap-4 flex-1 min-w-0">
      <Skeleton className="h-7 sm:h-8 w-3/4" />
      <div className="flex gap-3 items-center">
        <Skeleton className="h-5 w-24" />
        <Skeleton className="h-5 w-32" />
      </div>
    </div>
  );
}

function SchoolDetailsHeaderSkeleton() {
  return (
    <div className="flex items-start gap-3 sm:gap-4">
      <div className="flex-1 min-w-0">
        <div className="mb-2 sm:mb-2.5">
          <Skeleton className="h-5 sm:h-6 w-48 inline-block" />
          <Skeleton className="h-4 sm:h-5 w-24 ml-2 inline-block" />
        </div>
        <div className="flex flex-col gap-1 sm:gap-1.5">
          <Skeleton className="h-4 sm:h-5 w-32" />
        </div>
      </div>
    </div>
  );
}

function JobViewActionsSkeleton() {
  return (
    <div className="w-full border-t border-b border-line-faint py-4">
      <div className="flex flex-1 flex-col justify-center gap-4">
        <div className="space-y-1">
          <Skeleton className="h-5 w-36" />
          <Skeleton className="h-4 w-full max-w-[200px]" />
        </div>
        <div className="flex flex-col gap-2.5">
          <Skeleton className="h-12 w-full rounded-xl" />
        </div>
      </div>
    </div>
  );
}

function JobDetailsDescriptionSkeleton() {
  return (
    <div className="flex items-start flex-col gap-4">
      <Skeleton className="h-5 w-32" />
      <div className="bg-surface-subtle/30 rounded-lg p-5 w-full">
        <div className="flex flex-col gap-2 w-full">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-4/5" />
        </div>
      </div>
    </div>
  );
}

function DirectionAndShareButtonsSkeleton() {
  return (
    <div className="pt-6 flex flex-col gap-2">
      <Skeleton className="h-[52px] w-full rounded-lg" />
      <Skeleton className="h-[52px] w-full rounded-lg" />
    </div>
  );
}

export default function JobDetailsContentSkeleton() {
  return (
    <div className="w-full mx-auto px-4 sm:px-6 py-6">
      <div className="flex flex-col lg:flex-row w-full gap-6 lg:gap-8">
        <div className="contents lg:flex lg:flex-col lg:gap-6 lg:flex-1 lg:pr-2">
          <div className="order-1 lg:order-none">
            <JobDetailsHeaderSkeleton />
          </div>
          <div className="order-4 lg:order-none">
            <JobDetailsDescriptionSkeleton />
          </div>
        </div>
        <div className="contents lg:block lg:w-[320px] lg:flex-shrink-0 lg:self-stretch">
          <div className="order-2 lg:order-none">
            <SchoolDetailsHeaderSkeleton />
          </div>
          <div className="order-last lg:order-none">
            <JobViewActionsSkeleton />
          </div>
          <div className="order-last lg:order-none">
            <DirectionAndShareButtonsSkeleton />
          </div>
        </div>
      </div>
    </div>
  );
}
